import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import { Switch, Route } from 'react-router-dom';
import requiredSync from '../../../../components/required-sync';
import orgAwareness from '../../../../components/organization-awearness';
import checkUserPermission from '../../../../components/check-user-permission';
import {
  getIsAdmin,
  getIsSuperAdmin,
  getIsPIUser,
  getIsUsingOrganizationSwitch,
  getIsOrganizationAdmin,
  getIsOrganizationManager,
} from '../../../Auth/AuthReducer';
import TeamIndexPage from './IndexPage';
import TeamDetailPage from './DetailPage';

class TeamsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderError() {
    return (
      <div className="alert alert-danger"><Fa name="exclamation-triangle" /> You do not have permission to manage any teams.</div>
    );
  }

  renderContent() {
    return (
      <Switch>
        <Route exact path="/teams" component={TeamIndexPage} />
        <Route path="/teams/:teamID" component={TeamDetailPage} />
      </Switch>
    );
  }

  render() {
    const { canManageRole } = this.props;
    return (
      <div>
        <Helmet title="My Sales Teams" />
        <div className="container">
          {canManageRole && this.renderContent()}
          {!canManageRole && this.renderError()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const isUsingOrganizationSwitch = getIsUsingOrganizationSwitch(state);
  const isOrganizationAdmin = getIsOrganizationAdmin(state);
  const isOrganizationManager = getIsOrganizationManager(state);

  const canManageRole = isSuperAdmin || isAdmin || isOrganizationAdmin || isOrganizationManager || (isPIUser && isUsingOrganizationSwitch);

  return {
    canManageRole,
  };
}

TeamsPage.propTypes = {
  canManageRole: PropTypes.bool,
};

TeamsPage.defaultProps = {
  canManageRole: false,
};

TeamsPage.contextTypes = {
  router: PropTypes.shape({}),
};

export default connect(mapStateToProps)(orgAwareness(checkUserPermission(requiredSync(TeamsPage), ['admin', 'manager'], '/')));
